export const environment = {
  production: true,
  isMaintenance: false,
  INNOVATE_API: 'https://stgedgeapi.innovatesample.com/api/v1/',
  INNOVATE_API_V2: 'https://stgedgeapi.innovatesample.com/api/v2/',
  newBEHost: 'https://stagediysamplingapi.innovatesample.com/api/v2/',
  pointClubDomain: 'https://stage-pc-node.pointclub.com/',
  surveyFlow_Backend: 'https://stagesurveyflow-api.answerplatform.com/api/v1/',
  ROUTER_API: 'https://routerstageapi.innovatesample.com/api/v1/',
  questionKeys: ['AGE', 'GENDER', 'ZIPCODES', 'EDUCATION', 'ETHNICITY', 'REGION', 'STATE', 'INCOME', 'EMPLOYMENT', 'CORE_ACCULTURATION_0001','DMA_CODE','DMA_NAME'],
  questionIds: [1, 2, 3, 4, 5, 7, 8, 13, 2437, 2438, 2439, 3434],
  sampleChainApiUrl: 'https://staging.rtymgt.com/api/v3/respondents/',
  // Sample Chain
  sampleChain: {
    secretKey: "93f02271-e4df-4a31-8af8-5def143e626e",
    privateKey: "64b839d1-4cb2-47f2-899e-fbb6e15146a9"
  },
  opinionRoute: {
    eventId: 'SR_2024'
  },
  HOSupplierCode : [5944],
  'DFIQ_S2S_API_ENABLED' : true,
  secretKeyToEncDcryPayload: 'innovateStaging',
  VERISOUL: {
    ENV: 'staging',
    PROJECT_ID: '7d31e19f-b354-429b-8179-99e34c587ea5',
    CUSTOM_DOMAIN: 'js.verisoul.ai'
  }
};